import React from "react";
import { SubscriberArticle } from "../../../../amorg-common";
import { articleValidation } from "../../../../amorg-common/modules/fieldValidation/fields/articleValidation";
import { setCustomRequirements } from "../../../../api/siteArticlesClientApi";
import { CollapsiblePanel } from "../../../../designSystem/collapsible/CollapsiblePanel";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { FormField } from "../../../../designSystem/formField/FormField";
import { Label } from "../../../../designSystem/Label";
import { Toggletip } from "../../../../designSystem/Toggletip";
import { Small } from "../../../../designSystem/typography/Body";
import { toDateTimeString } from "../../../../utils/date";
import { HtmlEditorViewer } from "../../../../designSystem/inputs/HtmlEditorViewer";
import { HtmlEditorWithAutoSave } from "../../../../designSystem/inputs/HtmlEditorWithAutoSave";
import { LoadingPageOverlay } from "../../../../designSystem/LoadingPageOverlay";

type RequirementFieldsProps = {
    article: SubscriberArticle,
    onUpdated: () => void;
};
export function RequirementFields (props: RequirementFieldsProps): JSX.Element
{
    const [loading, setLoading] = React.useState(false);
    const [requirementsError, setRequirementsError] = React.useState<string>('');

    async function handleRequirementsSave(content:string): Promise<boolean>
    {
        let error = '';
        if(!articleValidation.siteArticleRequirements.requirementsText(content))
        {
            error = 'Må ikke overstige 5000 tegn';
        }
        else{
            setLoading(true);
            error = (await setCustomRequirements(props.article.articleId, content)).isSuccess
                ? ''
                : 'Der opstod en uventet fejl. Prøv igen eller kontakt support.';
            setLoading(false);
            
            if(!error)
            {
                props.onUpdated();
            }
        }

        setRequirementsError(error);
        return !error;
    }

    return (

        <>
            <LoadingPageOverlay loading={loading} />

            <CollapsiblePanel
                defaultOpen={props.article.customRequirements === null || props.article.customRequirements.requirementsText === ''}
                closedOrDefaultHeader={
                    <Flex gap={8} alignItems="center">
                        <Label>
                            Princip for juridisk forpligtelse
                        </Label>
                        <Toggletip maxWidth='50%'>
                            Det er lovpligtigt at I som organisation tager stilling til hvordan I overholder loven i praksis.
                            Derfor skal I udfylde dette punkt om &quot;Juridisk forpligtelse&quot; ved at beskrive hvordan I er &quot;lovmedholdelige&quot;.
                            I skal altså beskrive hvordan I, i praksis, overholder loven. Dette er en del af at kunne gennemgå audits på området
                        </Toggletip>
                    </Flex>
                }>
                
                <HtmlEditorViewer content={props.article.requirements} />

            </CollapsiblePanel>

            <FormField
                label="Praksis"
                toolTip="Beskriv hvordan I i praksis overholder loven"
                inputComponent={

                    <Flex flexDirection='column' gap={4}>
                        <HtmlEditorWithAutoSave
                            id='requirements-html-editor'
                            value={props.article.customRequirements?.requirementsText || ''}
                            errorMessage={requirementsError}
                            onSave={handleRequirementsSave}
                            onCancel={() => setRequirementsError('')}
                        />
                        <Flex justifyContent='flex-end'>
                            {props.article.customRequirements?.lastEdited &&
                                <Small>sidst redigeret {toDateTimeString(props.article.customRequirements.lastEdited.date)} af {props.article.customRequirements.lastEdited.name}</Small>
                            }
                        </Flex>
                    </Flex>
                }
            />
        </>
    );
}